<template>
  <standard-container
    :title="$t('stats.projects')"
    overflow="hidden"
    content-height="8vh"
    footer-height="0px"
  >
    <template v-slot:content>
      <v-flex>
        <v-row>
          <v-col>
            <v-autocomplete
              v-model="projectSelected"
              :label="$t('stats.project-name')"
              :items="projects"
              :disabled="disabled"
              prepend-icon="mdi-file-document-edit-outline"
              hide-details
              clearable
              @change="setProject()"
            />
          </v-col>
        </v-row>
      </v-flex>
    </template>
  </standard-container>
</template>

<script>
// Components
import standardContainer from "../Common/StandardContainer";

// Connectors
import { StatsConnector } from "../Database/StatsConnector";

export default {
  components: {
    standardContainer,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statsConnector: new StatsConnector(this.$store.state.user),
      projectSelected: "",
      projects: [],
    };
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.createProjectList();
    }
  },
  methods: {
    createProjectList() {
      this.statsConnector
        .getProjects()
        .then((response) => {
          this.projects = response;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setProject() {
      this.$emit("projectDefined", this.projectSelected);
    },
  },
};
</script>

<style></style>
